import state from './catalogState'
import mutations from './catalogMutations'
import getters from './catalogGetters'
import actions from './catalogActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
